<script setup lang="ts">
import { HgRadioButton } from '@smg-real-estate/domus';
import { ref, watch } from 'vue';

import FormHoverState from '@/components/common/FormHoverState';

interface Props {
  name: string;
  label: string;
  value: string;
  checked?: string;
}

const props = withDefaults(defineProps<Props>(), {
  checked: '',
});

const emit = defineEmits<{
  onClick: [value: string];
}>();

// Reactive data
const isChecked = ref(props.checked);

// Template ref
const formRadioBoxEvent = ref<HTMLDivElement>();

// Watch for prop changes
watch(
  () => props.checked,
  (value) => {
    isChecked.value = value;
  },
);
</script>

<template>
  <FormHoverState :selected="value === isChecked">
    <div ref="formRadioBoxEvent" :class="$style.wrapper" @click="emit('onClick', value)">
      <span>{{ label }}</span>
      <HgRadioButton v-model="isChecked" :inputValue="value" :name="name" label="" />
    </div>
  </FormHoverState>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 0 $space-100;
  border: 1px solid $color-grey-50;
  border-radius: $border-radius-l;
}
</style>
